module.exports = __webpack_public_path__ + "img/0.48f07bd9.jpg";